export default "__VITE_ASSET__74e77b70__$_?component__"